import {
    stakeholderApplyModelUpdate,
    stakeholderCancelModelUpdate
} from "../../../../actions/stakeholder-actions"
import buildEditFormActionButtonsWidgetContainer from "../../../common/build-edit-form-action-buttons-widget-container"

export default buildEditFormActionButtonsWidgetContainer(
    stakeholderApplyModelUpdate,
    stakeholderCancelModelUpdate,
    "stakeholders"
)
